import { TemplateRef } from "@angular/core";

export enum TemplateType {
    Breadcrumb,
    SubMenu
}

export class TemplateWithType {
    constructor(public templateType: TemplateType, public template: TemplateRef<any>) {

    }
}
